export default "__VITE_ASSET__891e1dc9__"